// Add To Cart Function is on THEME.JS
class BundleProduct extends HTMLElement {
  constructor() {
    super();
    this.addProductToBundle = this.querySelector(".add-to-bundle")
    this.productImage = this.querySelector('.bundle-product-image');
    this.allBundleProducts = document.querySelectorAll(".bundle-product");
    this.bundleSummary = document.querySelector(".bundle-summary");
    this.removeProductFromBundle = this.querySelector(".remove-from-bundle");
    this.quantityProducts = document.getElementById('quantityProducts');
    this.valueBundleWithDiscount = document.getElementById('valueBundleWithDiscount');
    this.valueBundle = document.getElementById('valueBundle');
    this.valueDiscount = document.getElementById('valueDiscount');
    this.variantId = this.dataset.variant;
    this.discountBars = document.querySelectorAll('.bundle-discount');

    this.productImage.addEventListener("click", this.toggleProduct.bind(this));
    this.buttonAddBundleToCart = document.querySelector('.add-bundle-to-cart');
  }

  toggleProduct(){
    if (this.classList.contains('selected')) {
      this.removeProduct();
    } else {
      this.renderProduct();
    }
  }
  
  renderProduct() {
    this.classList.add('selected')
    const clonedImage = this.productImage.querySelector('img').cloneNode();
    const itemAdded = this.bundleSummary.querySelector('.bundle-summary-product:not(.added)');
    
    itemAdded.appendChild(clonedImage);
    itemAdded.classList.add('added');
    itemAdded.setAttribute('data-variant-added', this.variantId)
    
    itemAdded.insertAdjacentHTML('beforeend', `<div class="remove-from-bundle"><svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M13.918 6.45312V19.8821C13.918 20.9341 13.058 21.7941 12.0059 21.7941H3.33331C2.28129 21.7941 1.42126 20.9341 1.42126 19.8821V6.45312H13.918ZM10.5356 9.22475C10.5356 9.00609 10.7121 8.82936 10.9273 8.82936C11.1424 8.82936 11.3227 9.00609 11.3227 9.22475V18.2428C11.3227 18.4576 11.1462 18.6344 10.9273 18.6344C10.7083 18.6344 10.5356 18.4576 10.5356 18.2428V9.22475ZM7.27611 9.22475C7.27611 9.00609 7.45257 8.82936 7.66772 8.82936C7.88287 8.82936 8.06316 9.00609 8.06316 9.22475V18.2428C8.06316 18.4576 7.88639 18.6344 7.66772 18.6344C7.44905 18.6344 7.27611 18.4576 7.27611 18.2428V9.22475ZM4.01658 9.22475C4.01658 9.00609 4.19333 8.82936 4.412 8.82936C4.63067 8.82936 4.80361 9.00609 4.80361 9.22475V18.2428C4.80361 18.4576 4.62715 18.6344 4.412 18.6344C4.19685 18.6344 4.01658 18.4576 4.01658 18.2428V9.22475Z" fill="black"/><path d="M13.5496 2.82889H10.6087V2.34146C10.6087 1.94224 10.5204 1.5697 10.3478 1.29741C10.1558 0.986419 9.86766 0.794434 9.49921 0.794434H5.84425C5.47199 0.794434 5.18385 0.986419 4.99185 1.29741C4.8192 1.57 4.73068 1.94224 4.73068 2.34146V2.82889H1.78977C0.898969 2.82889 0.169678 3.55463 0.169678 4.44509V5.6697H15.1697V4.44509C15.1697 3.55434 14.4401 2.82889 13.5496 2.82889ZM5.5139 2.34146C5.5139 2.08411 5.56373 1.85783 5.65607 1.70805C5.7059 1.62745 5.77126 1.57762 5.84425 1.57762H9.49921C9.56838 1.57762 9.63346 1.62745 9.68358 1.70805C9.77562 1.85783 9.82575 2.0844 9.82575 2.34146V2.82889H5.51419L5.5139 2.34146Z" fill="black"/></svg></div>`);
    this.updateInformation();
    this.updateRemoveProduct()
  }

  updateRemoveProduct() {
    this.removeFromBundleButtons = document.querySelectorAll('.bundle-summary-products .remove-from-bundle');

    this.removeFromBundleButtons.forEach(button => {
      button.addEventListener('click', (event) => { 
        const parentElement = event.currentTarget.closest('[data-variant-added]'); 
        if (parentElement === null) return

        const variantAdded = parentElement.getAttribute('data-variant-added');
        const itemSelected = document.querySelector(`[data-variant="${variantAdded}"]`);
        itemSelected.classList.remove('selected');
          
        document.querySelector('.bundle-summary-products').insertAdjacentHTML('beforeend', `<div class="bundle-summary-product"><svg width="173" height="200" viewBox="0 0 173 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.25" y="1.25" width="170.482" height="197.347" fill="white" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="13 13"></rect></svg></div>`);
        parentElement?.remove();
        button.replaceWith(button.cloneNode(true));
        this.updateInformation()
      });
    });
  }

  removeProduct() {
    this.classList.remove('selected');
    const itemSelected = this.bundleSummary.querySelector(`[data-variant-added="${this.variantId}"]`);
    itemSelected.remove();

    this.bundleSummary.querySelector('.bundle-summary-products').insertAdjacentHTML('beforeend', `<div class="bundle-summary-product"><svg width="173" height="200" viewBox="0 0 173 200" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1.25" y="1.25" width="170.482" height="197.347" fill="white" stroke="black" stroke-width="2.5" stroke-linecap="round" stroke-dasharray="13 13"></rect></svg></div>`);
    this.updateInformation()
  }

  updateInformation () {
    const addedProducts = this.bundleSummary.querySelectorAll('.bundle-summary-product.added');
    this.quantityProducts.innerText = addedProducts.length > 0 ? `(${addedProducts.length})` : '';

    this.discountBars.forEach((discount, index) => {
      if (index <= (addedProducts.length - 1)) {
        discount.classList.add('selected')
      } else {
        discount.classList.remove('selected')
      }
    });

    this.updatePrice()
    this.updateAddProductStatus()
  }

  updatePrice() {
    let totalPrice = 0;
    let discount = 0;
    let totalPriceWithDiscount = 0;

    const selectedCards = document.querySelectorAll('.bundle-product.selected');
    if (selectedCards.length === 0) {
      this.valueBundleWithDiscount.innerText = '';
      this.valueBundle.innerText = '';
      this.buttonAddBundleToCart.disabled = true;
      return
    }

    selectedCards.forEach(selectedCard => {           
      const jsonData = JSON.parse(selectedCard.querySelector(`script[type="application/json"][data-json-id]`).textContent);
      totalPrice += Number(jsonData.price);
    });

    switch (selectedCards.length) {
      case 1:
        discount = 0;
        break;
      case 2:
        discount = 0.05;
        break;
      case 3:
        discount = 0.10;
        break;
      case 4:
        discount = 0.15;
        break;
      case 5:
        discount = 0.20;
        break;
      case 6:
        discount = 0.25;
        break;
      default:
        discount = 0;
    }

    const discountAmount = totalPrice * discount;
    totalPriceWithDiscount = totalPrice * (1 - discount);

    this.valueDiscount.innerText = selectedCards.length <= 1 ? '' : Shopify.formatMoney(discountAmount); 
    this.valueBundle.innerText = selectedCards.length <= 1 ? '' : Shopify.formatMoney(totalPrice); 

    this.valueBundleWithDiscount.innerText = Shopify.formatMoney(totalPriceWithDiscount);
    this.buttonAddBundleToCart.disabled = false;
  }

  updateAddProductStatus(){
    const disabled = this.bundleSummary.querySelectorAll('.bundle-summary-product:not(.added)').length === 0;

    this.allBundleProducts.forEach(bundleContainer => {
      if (disabled && !bundleContainer.classList.contains('selected')) {
        bundleContainer.classList.add('disabled');
      } else {
        bundleContainer.classList.remove('disabled');
      }
    });
  }
}

customElements.define("bundle-product", BundleProduct);

const openButton = document.querySelector('.bundle-summary-open');

openButton.addEventListener('click', function() {
    const summary = document.querySelector('.bundle-summary');
    const summaryContainer = summary.querySelector('.bundle-summary-container')
    summary.classList.toggle('active');

    if (summary.classList.contains('active')) {
      summaryContainer.style.maxHeight = summaryContainer.scrollHeight + 'px';
    } else {
      summaryContainer.style.maxHeight = '0';
    }
});

